import { render, staticRenderFns } from "./SettingsSupplyChain.vue?vue&type=template&id=c5889eca&scoped=true&"
import script from "./SettingsSupplyChain.vue?vue&type=script&lang=js&"
export * from "./SettingsSupplyChain.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSupplyChain.vue?vue&type=style&index=0&id=c5889eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5889eca",
  null
  
)

export default component.exports